import { useEffect, useRef, useState } from "react";

const CARS_SHIPPED = 103;

function Services() {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
          }
        });
      },
      { threshold: 0.5 }
    );
    if (counterRef.current) observer.observe(counterRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  useEffect(() => {
    if (!hasAnimated) return;
    let current = 0;
    const increment = CARS_SHIPPED / 50;
    const timer = setInterval(() => {
      current += increment;
      if (current >= CARS_SHIPPED) {
        setCount(CARS_SHIPPED);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 30);
    return () => clearInterval(timer);
  }, [hasAnimated]);

  return (
    <section className="section" id="services">
      <div className="container">
        <h2 className="section-title">What We Offer</h2>
        <p className="section-subtitle">
          If security is important for you but you don't want to break the bank, we work closely with you to source and ship high-quality, pre-owned armored vehicles from Colombia.
          Together, we'll find exactly what you're looking for - low mileage, well-maintained, and 3rd party thorough inspection.
        </p>

        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">🔍</div>
            <h3>Vehicle Sourcing</h3>
            <p>Working together with you, we locate and acquire the exact armored vehicles you desire based on your specifications and protection requirements.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🔧</div>
            <h3>Technical Inspection</h3>
            <p>Professional evaluation of all security systems, armor integrity, and mechanical condition by certified experts.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🚢</div>
            <h3>Global Shipping</h3>
            <p>Door-to-door delivery coordination to your specified destination with secure container shipping (FOB).</p>
          </div>
        </div>

        <div className="track-record" ref={counterRef}>
          <h3>Our Track Record</h3>
          <p>We have shipped over 100 cars to Europe, Latin America, America and Canada</p>
          <div className="track-record-counter">
            <p>Total Cars Shipped To Date</p>
            <p className="counter-value">{count}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
